import { setKeyValue } from 'modules/keyValueStore/actions';
import { APP_STATUS_STORE_KEY } from './appStatus.constants';

export const setAppStatus = (data) => setKeyValue(APP_STATUS_STORE_KEY, data);
